import React, { useCallback, useRef, useState } from 'react';

import Form, { ButtonItem, ButtonOptions, Item, Label, RequiredRule } from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';

import { IAuth, useAuth } from '../../../context/auth';

/* import './login-form.scss';
 */
export default function LoginForm() {
  const { signIn, loading }: IAuth = useAuth();
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const formData = useRef({});

  const onSubmit = useCallback(
    async (e) => {
      setLoadingSubmit(true);
      e.preventDefault && e.preventDefault();

      const { userName, password }: any = formData.current;

      try {
        await signIn!(userName, password);
      } catch (e) {}

      setTimeout(() => {
        setLoadingSubmit(false);
      }, 500);
    },
    [signIn],
  );

  return (
    <form className={'login-form'} onSubmit={onSubmit}>
      <Form formData={formData.current} disabled={loading}>
        <Item dataField={'userName'} editorType={'dxTextBox'} editorOptions={loginEditorOptions}>
          <RequiredRule message="Заполните поле логин" />

          <Label visible={false} />
        </Item>
        <Item dataField={'password'} editorType={'dxTextBox'} editorOptions={passwordEditorOptions}>
          <RequiredRule message="Заполните поле пароль" />
          <Label visible={false} />
        </Item>
        {/* <Item
					dataField={'rememberMe'}
					editorType={'dxCheckBox'}
					editorOptions={rememberMeEditorOptions}
				>
					<Label visible={false} />
				</Item> */}
        <ButtonItem>
          <ButtonOptions width={'100%'} type={'default'} useSubmitBehavior={true} disabled={loadingSubmit}>
            <span className="dx-button-text">
              {loadingSubmit ? <LoadIndicator width={'24px'} height={'24px'} visible={true} /> : 'Войти'}
            </span>
          </ButtonOptions>
        </ButtonItem>
        {/* <Item>
					<div className={'link'}>
						<Link to={'/reset-password'}>Забыли пароль?</Link>
					</div>
				</Item> */}
      </Form>
    </form>
  );
}

const loginEditorOptions = { stylingMode: 'filled', placeholder: 'Логин', mode: 'text' };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Пароль', mode: 'password' };
